export default __webpack_public_path__ + "static/media/parliament_hero.9e1f36c4.jpg";